import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const ToolTip = ({ children, placement, content }) => {
  return (
    <OverlayTrigger
      key={placement}
      placement={placement}
      overlay={
        <Tooltip id={`tooltip-top}`}>
          <strong>{content}</strong>
        </Tooltip>
      }
    >
      {children}
    </OverlayTrigger>
  );
};

export default ToolTip;
